import React, { useState } from 'react';
import classNames from 'classnames';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import ChecklistGroup from 'src/components/Checklist/ChecklistGroup';
import ChecklistItem from 'src/components/Checklist/ChecklistItem';
import CreateGroup from 'src/components/Checklist/CreateGroup';
import CreateItem from 'src/components/Checklist/CreateItem';

import { useCreateChecklist } from 'src/controllers/Checklist/CreateChecklistController';

import './styles.scss';
import LoadingScreen from 'src/components/LoadingScreen';
import { Toast } from 'primereact/toast';

const CheckListForm: React.FC = () => {
	const { getChecklist, handleChecklist } = useCreateChecklist();
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [groupIn, setGroupIn] = useState(false);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [itemIn, setItemIn] = useState(false);

	if (getChecklist.loading) {
		return <LoadingScreen />;
	}

	return (
		<div style={{ height: '100%' }} className='card'>
			<Toast ref={getChecklist.toast} />
			<h5>Criação de Checklist</h5>
			<div className='checklistContainer'>
				<div className='p-grid p-fluid checklistForm'>
					<div className='checklistTitle'>
						<label htmlFor='titulo'>Título</label>
						<InputText
							id='titulo'
							placeholder='Informe um título para a checklist'
							{...getChecklist.formik.getFieldProps('DESCRICAO_CHECKLIST')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getChecklist.formik.touched.DESCRICAO_CHECKLIST &&
									getChecklist.formik.errors.DESCRICAO_CHECKLIST,
								'popup-form-inactive': !(
									getChecklist.formik.touched.DESCRICAO_CHECKLIST &&
									getChecklist.formik.errors.DESCRICAO_CHECKLIST
								),
							})}>
							{getChecklist.formik.errors.DESCRICAO_CHECKLIST}
						</div>
					</div>
					<div className='groupList'>
						<div className='info'>
							<span>Abaixo, você pode adicionar grupos que irão agrupar os itens do seu checklist.</span>
						</div>
						{/* <TransitionGroup> */}
						{getChecklist.groups.map(({ DESCRICAO_CHECKLISTGRUPO }: any, groupIndex: any) => (
							// <CSSTransition key={groupIndex} in={groupIn} timeout={{ enter: 200, exit: 400 }} classNames="" unmountOnExit>
							<ChecklistGroup
								key={groupIndex}
								value={DESCRICAO_CHECKLISTGRUPO}
								groupIndex={groupIndex}
								onChange={(event) => handleChecklist.updateGroup(event, groupIndex)}
								onDelete={() => handleChecklist.deleteGroup(groupIndex)}
								children={
									<div>
										{/* <TransitionGroup> */}
										{getChecklist.groups[groupIndex].LISTAITENS.map(
											({ DETALHAMENTO }: any, itemIndex: any) => (
												// <CSSTransition key={itemIndex} in={itemIn} timeout={{ enter: 200, exit: 400 }} classNames="" unmountOnExit>
												<ChecklistItem
													key={itemIndex}
													value={DETALHAMENTO}
													onChange={(event) =>
														handleChecklist.updateItem(event, itemIndex, groupIndex)
													}
													onDelete={() => handleChecklist.deleteItem(itemIndex, groupIndex)}
												/>
												// </CSSTransition>
											)
										)}
										{/* </TransitionGroup> */}
										<CreateItem
											onSubmit={() => {
												handleChecklist.addNewItem(groupIndex);
												setItemIn(true);
											}}
										/>
									</div>
								}
							/>
							// </CSSTransition>
						))}
						{/* </TransitionGroup> */}
						<CreateGroup
							onClick={() => {
								handleChecklist.addNewGroup();
								setGroupIn(true);
							}}
						/>
					</div>

					<div className='buttonContainer'>
						<div className=''>
							<Button type='submit' label='Salvar' onClick={() => getChecklist.formik.handleSubmit()} />
						</div>

						<div className=''>
							<Button
								type='button'
								label='Limpar'
								className='p-button-secondary'
								// onClick={() => history.goBack()}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CheckListForm;
